<template>
  <div id="Home">
    <v-img src="./aes_logo.png" contain height="100"></v-img>
  </div>
</template>

<script>
export default {
    name: 'Home',
    components: {},
    data: () => ({}),
    computed: {},
    methods: {},
    mounted() {}
};
</script>
